import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, watch } from 'vue';
import { ElTree } from 'element-plus';
import 'element-plus/es/components/tree/style/css'

import global from '@/component-create/utils/global';
import { GLOBAL_DATA } from '@/component-create/utils/global-enum';
import { log } from '@/component-create/utils/log';
import { Search } from '@icon-park/vue-next';
export default /*@__PURE__*/_defineComponent({
  __name: 'XSearchTree',
  props: {
    url: String,
    params: Object,
    data: {
      type: Array,
      default: () => []
    },
    label: {
      type: [String, Function],
      default: 'label'
    },
    value: {
      type: [String, Function],
      default: 'value'
    },
    format: Function,
    elTreeProp: Object
  },
  emits: ['check-change', 'current-change', 'node-click', 'node-contextmenu', 'node-collapse', 'node-expand', 'check', 'node-drag-start', 'node-drag-end', 'node-drop', 'node-drag-leave', 'node-drag-enter', 'node-drag-over'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const prop = __props;
    const TREE_REQUEST = global.globalVal[GLOBAL_DATA.TREE_REQUEST];
    const treeData = ref([]);
    const filterText = ref('');
    const treeRef = ref();
    if (prop.url) {
      load();
    }
    watch(filterText, val => {
      treeRef.value.filter(val);
    });
    /**
     * 过滤
     * @param value 搜索值
     * @param data 树节点数据
     */
    const filterNode = (value, data) => {
      if (!value) return true;
      return data.label.includes(value);
    };
    /**
     * 加载
     * @param params 请求参数
     */
    function load(params = {}) {
      const param = {
        ...prop.params,
        ...params
      };
      if (TREE_REQUEST) {
        TREE_REQUEST(prop.url, param).then(res => {
          treeData.value = prop.format ? prop.format(res.data) : autoFormat(res.data);
        });
      } else {
        log('XSearchTree', '加载失败，未配置搜索树加载请求接口：' + GLOBAL_DATA.TREE_REQUEST, 'error');
      }
    }
    /**
     * 自动格式化
     * @param data 待格式化数据
     */
    function autoFormat(data) {
      if (!data) {
        return [];
      }
      const newData = data.map(item => {
        return {
          ...item,
          label: typeof prop.label === 'string' ? item[prop.label] : prop.label(item),
          value: typeof prop.value === 'string' ? item[prop.value] : prop.value(item),
          children: autoFormat(item.children)
        };
      });
      return newData;
    }
    function elTreeEventEmit(event, ...args) {
      emits(event, ...args);
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_input, {
        class: "search",
        modelValue: filterText.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filterText.value = $event),
        placeholder: "请输入搜索关键字",
        "prefix-icon": _unref(Search)
      }, null, 8, ["modelValue", "prefix-icon"]), _createVNode(_unref(ElTree), _mergeProps({
        ref_key: "treeRef",
        ref: treeRef,
        class: "filter-tree",
        data: treeData.value,
        "default-expand-all": "",
        "filter-node-method": filterNode,
        "empty-text": "暂无数据"
      }, __props.elTreeProp, {
        onNodeClick: _cache[1] || (_cache[1] = (...args) => elTreeEventEmit('node-click', ...args)),
        onNodeContextmenu: _cache[2] || (_cache[2] = (...args) => elTreeEventEmit('node-contextmenu', ...args)),
        onCheckChange: _cache[3] || (_cache[3] = (...args) => elTreeEventEmit('check-change', ...args)),
        onCheck: _cache[4] || (_cache[4] = (...args) => elTreeEventEmit('check', ...args)),
        onCurrentChange: _cache[5] || (_cache[5] = (...args) => elTreeEventEmit('current-change', ...args)),
        onNodeExpand: _cache[6] || (_cache[6] = (...args) => elTreeEventEmit('node-expand', ...args)),
        onNodeCollapse: _cache[7] || (_cache[7] = (...args) => elTreeEventEmit('node-collapse', ...args)),
        onNodeDragStart: _cache[8] || (_cache[8] = (...args) => elTreeEventEmit('node-drag-start', ...args)),
        onNodeDragEnter: _cache[9] || (_cache[9] = (...args) => elTreeEventEmit('node-drag-enter', ...args)),
        onNodeDragLeave: _cache[10] || (_cache[10] = (...args) => elTreeEventEmit('node-drag-leave', ...args)),
        onNodeDragOver: _cache[11] || (_cache[11] = (...args) => elTreeEventEmit('node-drag-over', ...args)),
        onNodeDragEnd: _cache[12] || (_cache[12] = (...args) => elTreeEventEmit('node-drag-end', ...args)),
        onNodeDrop: _cache[13] || (_cache[13] = (...args) => elTreeEventEmit('node-drop', ...args))
      }), null, 16, ["data"])]);
    };
  }
});